"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDGs = void 0;
exports.SDGs = [
    {
        description: 'End poverty in all its forms everywhere',
        goalNumber: 1,
        title: 'No Poverty',
    },
    {
        description: 'End hunger, achieve food security and improved nutrition and promote sustainable agriculture',
        goalNumber: 2,
        title: 'Zero Hunger',
    },
    {
        description: 'Ensure healthy lives and promote well-being for all at all ages',
        goalNumber: 3,
        title: 'Good Health and Well-being',
    },
    {
        description: 'Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all',
        goalNumber: 4,
        title: 'Quality Education',
    },
    {
        description: 'Achieve gender equality and empower all women and girls',
        goalNumber: 5,
        title: 'Gender Equality',
    },
    {
        description: 'Ensure availability and sustainable management of water and sanitation for all',
        goalNumber: 6,
        title: 'Clean Water and Sanitation',
    },
    {
        description: 'Ensure access to affordable, reliable, sustainable and modern energy for all',
        goalNumber: 7,
        title: 'Affordable and Clean Energy',
    },
    {
        description: 'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all',
        goalNumber: 8,
        title: 'Decent Work and Economic Growth',
    },
    {
        description: 'Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation',
        goalNumber: 9,
        title: 'Industry, Innovation and Infrastructure',
    },
    {
        description: 'Reduce inequality within and among countries',
        goalNumber: 10,
        title: 'Reduced Inequality',
    },
    {
        description: 'Make cities and human settlements inclusive, safe, resilient and sustainable',
        goalNumber: 11,
        title: 'Sustainable Cities and Communities',
    },
    {
        description: 'Ensure sustainable consumption and production patterns',
        goalNumber: 12,
        title: 'Responsible Consumption and Production',
    },
    {
        description: 'Take urgent action to combat climate change and its impacts*',
        goalNumber: 13,
        title: 'Climate Action',
    },
    {
        description: 'Conserve and sustainably use the oceans, seas and marine resources for sustainable development',
        goalNumber: 14,
        title: 'Life Below Water',
    },
    {
        description: 'Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, combat desertification, and halt and reverse land degradation and halt biodiversity loss',
        goalNumber: 15,
        title: 'Life on Land',
    },
    {
        description: 'Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels',
        goalNumber: 16,
        title: 'Peace and Justice Strong Institutions',
    },
    {
        description: 'Strengthen the means of implementation and revitalize the global partnership for sustainable development',
        goalNumber: 17,
        title: 'Partnerships to achieve the Goal',
    },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VzdGFpbmFibGUtZGV2ZWxvcG1lbnQtZ29hbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tbW9uL3N1c3RhaW5hYmxlLWRldmVsb3BtZW50LWdvYWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVFhLFFBQUEsSUFBSSxHQUFtQjtJQUNsQztRQUNFLFdBQVcsRUFBRSx5Q0FBeUM7UUFDdEQsVUFBVSxFQUFFLENBQUM7UUFDYixLQUFLLEVBQUUsWUFBWTtLQUNwQjtJQUNEO1FBQ0UsV0FBVyxFQUFFLDhGQUE4RjtRQUMzRyxVQUFVLEVBQUUsQ0FBQztRQUNiLEtBQUssRUFBRSxhQUFhO0tBQ3JCO0lBQ0Q7UUFDRSxXQUFXLEVBQUUsaUVBQWlFO1FBQzlFLFVBQVUsRUFBRSxDQUFDO1FBQ2IsS0FBSyxFQUFFLDRCQUE0QjtLQUNwQztJQUNEO1FBQ0UsV0FBVyxFQUFFLHNHQUFzRztRQUNuSCxVQUFVLEVBQUUsQ0FBQztRQUNiLEtBQUssRUFBRSxtQkFBbUI7S0FDM0I7SUFDRDtRQUNFLFdBQVcsRUFBRSx5REFBeUQ7UUFDdEUsVUFBVSxFQUFFLENBQUM7UUFDYixLQUFLLEVBQUUsaUJBQWlCO0tBQ3pCO0lBQ0Q7UUFDRSxXQUFXLEVBQUUsZ0ZBQWdGO1FBQzdGLFVBQVUsRUFBRSxDQUFDO1FBQ2IsS0FBSyxFQUFFLDRCQUE0QjtLQUNwQztJQUNEO1FBQ0UsV0FBVyxFQUFFLDhFQUE4RTtRQUMzRixVQUFVLEVBQUUsQ0FBQztRQUNiLEtBQUssRUFBRSw2QkFBNkI7S0FDckM7SUFDRDtRQUNFLFdBQVcsRUFDVCxzSEFBc0g7UUFDeEgsVUFBVSxFQUFFLENBQUM7UUFDYixLQUFLLEVBQUUsaUNBQWlDO0tBQ3pDO0lBQ0Q7UUFDRSxXQUFXLEVBQ1QsMkdBQTJHO1FBQzdHLFVBQVUsRUFBRSxDQUFDO1FBQ2IsS0FBSyxFQUFFLHlDQUF5QztLQUNqRDtJQUNEO1FBQ0UsV0FBVyxFQUFFLDhDQUE4QztRQUMzRCxVQUFVLEVBQUUsRUFBRTtRQUNkLEtBQUssRUFBRSxvQkFBb0I7S0FDNUI7SUFDRDtRQUNFLFdBQVcsRUFBRSw4RUFBOEU7UUFDM0YsVUFBVSxFQUFFLEVBQUU7UUFDZCxLQUFLLEVBQUUsb0NBQW9DO0tBQzVDO0lBQ0Q7UUFDRSxXQUFXLEVBQUUsd0RBQXdEO1FBQ3JFLFVBQVUsRUFBRSxFQUFFO1FBQ2QsS0FBSyxFQUFFLHdDQUF3QztLQUNoRDtJQUNEO1FBQ0UsV0FBVyxFQUFFLDhEQUE4RDtRQUMzRSxVQUFVLEVBQUUsRUFBRTtRQUNkLEtBQUssRUFBRSxnQkFBZ0I7S0FDeEI7SUFDRDtRQUNFLFdBQVcsRUFBRSxnR0FBZ0c7UUFDN0csVUFBVSxFQUFFLEVBQUU7UUFDZCxLQUFLLEVBQUUsa0JBQWtCO0tBQzFCO0lBQ0Q7UUFDRSxXQUFXLEVBQ1QsOExBQThMO1FBQ2hNLFVBQVUsRUFBRSxFQUFFO1FBQ2QsS0FBSyxFQUFFLGNBQWM7S0FDdEI7SUFDRDtRQUNFLFdBQVcsRUFDVCxtTEFBbUw7UUFDckwsVUFBVSxFQUFFLEVBQUU7UUFDZCxLQUFLLEVBQUUsdUNBQXVDO0tBQy9DO0lBQ0Q7UUFDRSxXQUFXLEVBQ1QsMEdBQTBHO1FBQzVHLFVBQVUsRUFBRSxFQUFFO1FBQ2QsS0FBSyxFQUFFLGtDQUFrQztLQUMxQztDQUNPLENBQUMifQ==